// 注意：一定是 exports，不是 export，否则会报错，报错信息是下列的中的内容不是 string
module.exports = {
  headLang: {
    title: "Merchant Management Background",
    welcome: "Welcome, ",
    changePassword: "Reset Password",
    logout: "Logout",
    updatePassword: "Change Password",
    oldPassword: "Old password",
    newPassword: "New password",
    surePassword: "Confirm the New Password",
    chooseShop: "Please choose a Shop",
    currentShop: "Current Shop: ",
    notChangeShop: "Do not Switch",
    changeShop: "Switch Shop"
  },
  index: {
    basicInfo: "Basic Information",
    accountBalance: "Account Balance",
    setAmount: "Settle Amount",
    frozenAmount: "Freeze Amount",
    storeManagement: "Merchant Info",
    amountManagemnet: "Account",
    orderFlow: "Orders",
    receiptCode: "QRCode",
    download: "Development DOC",
    noticeMessage: "Notice",
    wdTip: "Unread Message",
    refundReview: "Refund Approval",
    reviewTip: "",
    transaction: "Transaction",
    tranAmount: "Settlement Aomunt",
    tranJe: "Net Transaction",
    paySuccessAmount: "Received Amount",
    paySuccessNum: "Received Transactions",
    refundAmount: "Refund Amount",
    tranNum: "Number of Transaction",
    refundNum: "Refunded Transaction",
    YrefundAmount: "Refunded Amount",
    ZrefundAmount: "Refunding Amount",
    TrefundOrderNum: "Number Of Refund Orders",
    Getting:
      "Welcome to the WISH PAY Merchant Portal. Wishing you prosperity and business success!"
  },
  shInfo: {
    saoQrCodeTip: "Scan QR Code binding after data review",
    CPreview: "Cancel Preview",
    Preview: "Preview Information",
    keyTip:
      "The above KYB information is submitted by the merchant and confirmed by mistake.",
    BusinessInfo: "Business information",
    Documentupload: "Uploaded documents and photos",
    Currencytype: "Currency Type",
    BankAccountType: "Bank Account Type",
    BankCertificate: "Bank Certificate",
    BranchNumber: "Branch Number",
    bankNo: "Bank Number",
    Holdername: "Holder Name",
    BillBankData: "Bank Account Information",
    skData: "Collection Information",
    BillingCycle: "Billing Cycle",
    SHHB: "Receiving Currency",
    JSHB: "Settlement Currency",
    Storeinformation: "Store Information",
    contactJob: "Responsible Position",
    principal: "Principal",
    addTime: "Add Time",
    Businessnumber: "Business Registration Number",
    basis: "Information",
    merchantNo: "Merchant ID",
    merchantName: "Merchant Name",
    shortName: "Store Name",
    phone: "Cellphone Number",
    Referrer: "Recommended Staff",
    ReferrerPhone: "Referrer Mobile Number",
    bindRefPhone: "Binding promotion staff",
    refTip:
      "Tip: The mobile phone number must be a real and effective employee, no need to enter the mobile phone area code.",
    merchantState: "Approval Status",
    merchantGradeName: "Merchant Grade",
    address: "Address",
    shMobile: "Merchant Phone",
    mobile: "Contact Number",
    contactEmail: "Email",
    contactName: "Name of person in charge",
    contactMobile: "Contact of person in charge",
    idCardNumber: "ID Number",
    loginNum: "Merchant ID",
    loginPassword: "Login Password",
    industryName: "Industry",
    class: "Category",
    introduction: "Merchant Profile",
    jsInfo: "Bank information",
    openName: "Beneficiary Bank Account",
    openBank: "Beneficiary Bank",
    openNumber: "Bank Card number",
    jsMode: "Settlement Time",
    zjData: "ID Information",
    idCardFontImageUrl: "ID Card Front Photo",
    idCardBackImageUrl: "ID Card Back Photo",
    brImageUrl: "Business Registration Photo",
    bankCardImageUrl: "Bank Certificate Photo",
    brandImageUrl: "Door Sign Photo",
    roomImageUrl: "Shop environment - Checkout Photo",
    otherImageUrl: "Other photos",
    payInfo: "Transaction Fee",
    Systatus: "Status",
    tdNum: "ID",
    tdName: "Name",
    tdRate: "Transaction Fee",
    changeData: "Revise Information",
    changeMobile: "Reset Contact Number",
    sscompany: "Affiliation",
    ssAgent: "Affiliated Agent",
    keys: "Payment Key",
    loginInfo: "Login Information",
    others: "Other",
    auto: "Automatic Generated",
    tip: "10-25 Characters",
    upload: "Upload",
    tjCheck: "Submit review",
    changePhone: "Change Phone",
    phoneNumber: "Current mobile",
    getCode: "Get verification",
    code: "Verification",
    NewPhone: "New phone",
    Captcha: "Captcha",
    leixing: "Business type",
    ciImageUrl: "Company Registration Certificate",
    bankStatementFileUrl: "Bank Flow DOC Photo",
    shopOne: "Shop environment - The first",
    shopTwo: "Shop environment - Second",
    ProtocolCheckedText: "I have read and agree to abide by the agreement",
    xieyiTitle: "Wish Pay MERCHANT SERVICE TERMS OF USE",
    WishPayServiceAgreement: "Wish Pay Service Agreement",
    shengmingText: "Personal Account Settlement Statement",
    gsShengmingText: "Company Settlement Statement",
    CumulativeBounty: "Cumulative Bounty",
    AccountOpening: "Account Opening",
    DividendBonus: "Dividend Bonus",
    DevelopedMerchant: "Developed Merchant",
    CateringMerchant: "Catering Merchant",
    NonCatering: "Non-Catering Merchant",
    MyInvitationCode: "My Invitation Code",
    shTotal: "Summary By Business",
    mxTotal: "By Bounty Details",
    bountyAmount: "Total amount of Bounty",
    rTime: "Registration Time",
    srTime: "Income Time",
    sjtype: "Bounty Type",
    sourceName: "Source Business Name",
    sjje: "Prize Money",
    ServiceFeeRate: "Current Service Fee",
    SetServiceFeeRate: "Set Service Fee",
    SelectFw: "Selection Range：0~5%",
    ssmd: "Own store",
    ssjs: "Role",
    dyxm: "Clerk name",
    dysjh: "Clerk mobile phone number",
    xzdy: "New clerk",
    editzx: "Modify information",
    changeM: "Change phone",
    dxyzm: "SMS verification code",
    qrxz: "Confirm new",
    qrxg: "Confirm the changes",
    addmd: "New store"
  },
  zhInfo: {
    Settlement: "Transfer",
    jsLog: "Settlement Record",
    sqTime: "Apply Time",
    jsNum: "Bill Number",
    txStatus: "Status",
    skBank: "Beneficiary Bank",
    jsStatus: "Status",
    jsMoney: "Actual settlement amount",
    fee: "Service Charge",
    sjMoney: "Settled Smount",
    kyMoney: "Account Balance",
    jsBank: "Beneficiary Bank",
    jsBankNum: "Card Number",
    payee: "Beneficiary",
    note: "Info",
    dkTime: "Received Time",
    shAcount: "Accounts Receivable",
    bankName: "Bank Name",
    banknumber: "Bank Card Number",
    dqMoney: "Current Billable Amount",
    allMoney: "Full Settlement",
    dkInfo: "Payment Information",
    bankZzPhoto: "Bank Transfer Photo",
    NoPhoto: "No Photo"
  },
  ddInfo: {
    jyTime: "Transaction Time",
    jyDate: "Transaction Date",
    payTd: "Information",
    jyStatus: "Status",
    ptOrderNum: "WishPay Orders ID",
    payTdOrderNum: "Payment channel orders ID",
    paySuccessAmount: "Received Amount",
    paySuccessNum: "Received Transactions",
    tkSuccessNum: "Refunded transactions",
    orderStatus: "Status",
    orderAmount: "Amount",
    jyType: "Transaction type",
    payTdNum: "Information",
    applyTk: "Refund",
    orderDetail: "Details",
    shOrder: "Merchant order number",
    applyUserName: "Refund applicant",
    orderContent: "Order Content",
    payCountdown: "Payment Countdown",
    paymentAddress: "Order Payment Address",
    waitingGenerate: "Waiting to generate",
    generatePaymentAddress: "Generate Payment Address",
    reset: "Reset",
    copySuccess: "Copy successful",
    pleaseInputOrderContent: "Please fill in order content and amount first",
    submitSuccess: "Submit successful",
    pleaseInputRequired: "Please fill in required fields",
    copyPaymentAddress: "Copy Payment Address",
    pleaseInputValidAmount: "Please enter a valid amount",
    amountMustBeGreaterThanZero: "Amount must be greater than or equal to 0.02",
    amountMustBeLessThanMillion: "Amount must be less than 1,000,000",
    generateSuccess:
      "Generation successful, please copy order information to the payer!",
    generateFail: "Generation failed, please try again later!",
    copyPaymentInfo: "Copy payment information",
    merchantOrderNo: "Merchant order number"
  },
  tkInfo: {
    tkOrderNum: "Refund Order ID",
    payOrderNum: "Payment Order ID",
    tkStatus: "Refund States",
    tkTotal: "Refund Amount",
    tkyy: "Reason For Return",
    tkApplyTime: "Refund Application Time",
    tkFulfilTime: "Refund completion Time",
    dqRefund: "Refundable Amount",
    allRefund: "Full Refund",
    tkTip: "Tips: Enter a maximum of 2 decimal places for the refund amount",
    errorMessage1: "Hold up to two digits after the decimal point",
    errorMessage2: "Cannot be greater than the current refundable amount",
    tkSuccess: "Successful application",
    tkCheck: "Are you sure to review/reject the refund request?",
    exportTip:
      "The exported record data is the transaction stream that has been successfully paid.",
    errorMessage3: "Please select export flow time"
  },
  shrjInfo: {
    slMechanism: "Company Name",
    jyTotalMoney: "Received Amount",
    tkTotalMoney: "Total Refund Amount",
    TrAmount: "Transaction Amount",
    tkTotalNum: "Total Refund Transactions"
  },
  ewm: {
    tipTitle: "QR code",
    shName: "Display Name",
    showAll: "Full Name",
    showjc: "Store Name",
    noShow: "No Display",
    background: "Background Colour",
    payModeShow: "Payment",
    ewmLogo: "QRCode Logo",
    wx: "Wechat",
    alipay: "Alipay",
    downloadQCode: "Download QRCode",
    gdje: "Fixed Amount",
    ddje: "Order Amount",
  shopAll: "Full store name",
  shopShort: "Short store name",
    validTime: "Effective Time",
    alwaysValid: "Always Valid",
    tradeContent: "Transaction Content",
    visibleToPayer: "Visible to the payer",
  },
  config: {
    scanQR: "QR Code",
    unionpay: "Union Pay",
    wechatpay: "WeChat Pay",
    alipaypay: "Alipay",
    orderPayment: "Order Payment",
    copy: "Copy",
    minutes: "Minutes",
    bhfwf: "This amount does not include the service fee set by the merchant",
    unionPayTitle: "UnionPay QR Code",
    qrCodeDisplay: "QR Code Display:",
    collectionAmount: "Collection Amount",
    collectionAmountLabel: "Collection Amount:",
    generateUnionPayQR: "Generate UnionPay QR",
    generateWechatPayQR: "Generate Payment QR",
    generateAlipayQR: "Generate Payment QR",
    downloadQRCode: "Download QR Code",
    unionPayNotEnabled: "UnionPay Channel Not Enabled",
    wechatPayNotEnabled: "WeChat Pay Channel Not Enabled",
    alipayNotEnabled: "Alipay Channel Not Enabled",
    contactNotice:
      "Please contact your account manager or official customer service to apply for UnionPay channel",
    contactNoticeWechat:
      "Please contact your account manager or official customer service to apply for WeChat Pay channel",
    contactNoticeAlipay:
      "Please contact your account manager or official customer service to apply for Alipay channel",
    contactPhone: "Phone: 852 21170503",
    contactEmail: "Email: service@wishpay-global.com",
    acknowledged: "Acknowledged",
    downloadSuccess: "Download successful!",
    qrGenerateSuccess:
      "QR Code generated successfully, please download and send to the payer.",
    qrExpireNotice:
      "Please note that this QR code will automatically expire after payment is completed.",
    payAmountText: " Payment amount",
    orderContentText: " Goods or note information",
    payWalletLabel: "Payment Wallet:",
    alipayWallet: "Alipay"
  },
  onlineOrder: {
    title: "Online Transaction Orders",
    createTitle: "Create Online Order",
    status: "Order Status",
    actualAmount: "Actual Payment Amount",
    payMethod: "Payment Method",
    orderContent: "Order Content",
    orderNo: "Order Number",
    deliveryInfo: "Delivery Info",
    time: "Time",
    operate: "Operate",
    view: "View",
    ship: "Ship",
    shipTitle: "Ship",
    all: "All",
    pendingPayment: "Pending Payment",
    pendingShipment: "Pending Shipment",
    shipped: "Shipped",
    canceled: "Canceled",
    completed: "Completed",
    keywordPlaceholder: "Merchant Order No. / Buyer Info",
    search: "Search",
    noDelivery: "None",
    shipMethod: "Shipping Method",
    shipMethodLogistics: "Logistics",
    shipMethodSelf: "Non-Logistics",
    shipMethodSelfTip: "(In-store pickup / Door-to-door / Service complete)",
    logisticsPlatform: "Logistics Platform",
    logisticsNo: "Tracking Number",
    deliveryProof: "Delivery Proof",
    uploadDeliveryProof: "Please upload the delivery receipt",
    shipConfirm: "Confirm Ship",
    shipCancel: "Cancel",
    shipCancelTip: "Are you sure to cancel shipping?",
    shipSuccess: "Shipment successful",
    shipFail: "Shipment failed",
    pleaseEnterLogisticsPlatform: "Please enter the logistics platform",
    pleaseEnterLogisticsNo: "Please enter the tracking number",
    pleaseUploadProof: "Please upload the delivery proof",
    proofView: "View",
    proofDelete: "Delete",
    proofMaxTip: "Up to 3 proof images",
    imageTypeError: "Please upload image files",
    imageSizeError: "Image size cannot exceed 2MB",
    createTime: "Created",
    payTime: "Paid",
    shipTime: "Shipped",
    userPickupMethod: "User selected pickup method",
    orderDetail: "Order Detail",
    buyerInfo: "Buyer Info",
    copyAll: "Copy All",
    buyerName: "Name",
    buyerPhone: "Phone",
    buyerAddress: "Shipping Address",
    productInfo: "Product Info",
    productTotal: "Product Total",
    shippingFee: "Shipping Fee",
    storeDiscount: "Store Discount",
    actualPay: "Actual Pay",
    deliveryMethod: "Delivery Method",
    payMethodLabel: "Payment Method",
    createTimeLabel: "Order Created",
    payTimeLabel: "Order Paid",
    customerRemark: "Customer Remark",
    noRemark: "None",
    orderSource: "Order Source",
    orderPayLink: "Copy Pay Link",
    orderPay: "Order Pay",
    close: "Close",
    editBuyer: "Edit Buyer",
    orderAmount: "Order Amount",
    orderInfo: "Order Info",
    copySuccess: "Copied",
    copyFail: "Copy failed",
    buyerInfoEditTitle: "Buyer Info",
    buyerNameLabel: "Consignee:",
    buyerNamePlaceholder: "Please enter consignee name",
    buyerNameRequired: "Consignee name is required",
    buyerNameMax: "Consignee name max 20 chars",
    buyerPhoneLabel: "Phone:",
    buyerPhonePlaceholder: "Please enter phone number",
    buyerPhoneRequired: "Phone number is required",
    buyerPhoneMax: "Phone number max 20 digits",
    buyerRegionLabel: "Region:",
    regionPlaceholder: "Select province / city / district",
    regionRequired: "Please select region",
    provincePlaceholder: "Province",
    cityPlaceholder: "City",
    districtPlaceholder: "District",
    buyerAddressLabel: "Address:",
    buyerAddressPlaceholder: "Please enter detailed address",
    buyerAddressRequired: "Detailed address is required",
    buyerAddressMax: "Detailed address max 200 chars",
    buyerEditCancel: "Cancel",
    buyerEditConfirm: "Confirm",
    buyerEditSuccess: "Updated successfully"
  },
  md: {
    shfwf: "Merchant Service Fee",
    shcode: "Merchant Number",
    wechatNo: "Wechat ID",
    zd: "Head Office",
    fd: "Branch",
    skzl: "Collection Information",
    suoshu: "Head Office",
    mendianType: "Store Type",
    jsFee: "Settlement Rate",
    MinimumAmount: "Minimum Settlement Amount",
    lymc: "Source name",
    mdlx: "Store type",
    lylx: "Source type"
  },
  public: {
    startDate: "Start",
    to: "To",
    endDate: "End",
    inquire: "Enquire",
    clear: "Clear",
    NoNum: "NO.",
    operating: "Operate",
    pleaseEnter: "Enter",
    pleaseChoose: "Please Choose",
    look: "View",
    edit: "Edit",
    del: "Delete",
    ty: "Disable",
    qy: "Enable",
    sh: "Review",
    bh: "Reject",
    detail: "Orders Details",
    close: "Close",
    save: "Save",
    back: "Back",
    define: "Define",
    cancel: "Cancel",
    cancelSave: "Cancel Save",
    noTip: "No Data",
    prompt: "Prompt",
    successMsg: "Successful Operation",
    cancelMsg: "Cancelled",
    export: "Export Flow"
  },
  sceneTip: {
    offlineTag: "Offline Scenario",
    onlineTag: "Online Scenario",
    scanQR: "The aggregated QR code is suitable for offline transaction scenarios such as in-store collection and face-to-face scanning. Customers can complete the payment by scanning the same QR code via WeChat Pay or Alipay, achieving multiple uses with one single code.",
    orderPayment: "Link Payment is suitable for online transaction scenarios such as private domain customer groups of independent stores, online chat orders, and email communications. Its principle is consistent with payment links on PC websites, H5 malls, and mobile apps—users click the payment button and are redirected to the payment page to complete payment with flexible integration. The generated payment link orders can be managed for shipment on this page. For online transaction rate details, please consult your account manager.",
    wechatPay: "WeChat Dynamic Code is a face-to-face payment collection method. As a dynamically generated one-time payment code, scanning directly initiates payment, making it fast and high in success rate. It can effectively avoid risk control triggered by frequent use of aggregated payment codes, making it suitable for offline high-frequency collection scenarios, and can also serve as a reliable backup when aggregated QR code payments are intercepted.",
    alipayPay: "Alipay Dynamic Code is a face-to-face payment collection method. As a dynamically generated one-time payment code, scanning directly initiates payment, making it fast and high in success rate. It can effectively avoid risk control triggered by frequent use of aggregated payment codes, making it suitable for offline high-frequency collection scenarios, and can also serve as a reliable backup when aggregated QR code payments are intercepted."
  }
};



// WEBPACK FOOTER //
// ./src/common/lang/en.js